export const EmojiDictionary = {
    "😀": "Grinning Face",
    "😃": "Grinning Face with Big Eyes",
    "😄": "Grinning Face with Similing Eyes",
    "😁": "Beaming Face with Similing Eyes",
    "😆": "Grinning Squinting Face",
    "😅": "Grinning Face with Sweat",
    "🤣": "Rolling on the Floor Laughing",
    "😂": "Face with Tears of Joy",
    "🙂": "Slightly Smiling Face",
    "😉": "Winking Face",
    "😊": "Smiling Face with Similing Eyes",
    "😇": "Smiling Face with Halo",
    "🥰": "Smiling Face with Hearts",
    "😍": "Smiling Face with Heart Eyes",
    "🤩": "Star Struck",
    "😘": "Face Blowing a Kiss",
    "😗": "Kissing Face",
    "😚": "Kissing Face with Closed Eyes",
    "😙": "Kissing Face with Similing Eyes",
    "😏": "Smirking Face",
    "😋": "Face Savoring Food",
    "😛": "Face with Tongue",
    "😜": "Winking Face with Tongue",
    "🤪": "Zany Face",
    "😝": "Squinting Face with Tongue",
    "🤗": "Hugging Face",
    "🤭": "Face with Hand over Mouth",
    "🤫": "Shushing Face",
    "🤔": "Thinking Face",
    "🤤": "Drooling Face",
    "🤠": "Cowboy Hat Face",
    "🥳": "Partying Face",
    "😎": "Smiling Face with Sunglasses",
    "🤓": "Nerd Face",
    "🧐": "Face with Monocle",
    "🤐": "Zipper Mouth Face",
    "🤨": "Face with Raised Eyebrow",
    "😐": "Neutral Face",
    "😑": "Expressionless Face",
    "😶": "Face without Mouth",
    "🙃": "Upside-Down Face",
    "😒": "Unamused Face",
    "🙄": "Face with Rolling Eyes",
    "😬": "Grimacing Face",
    "😮": "Open Mouth Face",
    "🤥": "Lying Face",
    "😌": "Relieved Face",
    "😔": "Pensive Face",
    "😪": "Sleepy Face",
    "😴": "Sleeping Face",
    "😷": "Face with Medical Mask",
    "🤒": "Face with Thermometer",
    "🤕": "Face with Head Bandage",
    "🤢": "Nauseated Face",
    "🤮": "Face Vomiting",
    "🤧": "Sneezing Face",
    "🥵": "Hot Face",
    "🥶": "Cold Face",
    "🥴": "Woozy Face",
    "😵": "Dizzy Face",
    "🤯": "Exploding Head",
    "🥱": "Yawning Face",
    "😕": "Confused Facee",
    "😟": "Worried Face",
    "🙁": "Slightly Frowning Face",
    "😯": "Hushed Face",
    "😲": "Astonished Face",
    "😳": "Flushed Face",
    "🥺": "Pleading Face",
}